import { delay } from "redux-saga/effects";

export function* middleSaga(s) {
  // console.log(s);
  // yield delay(100);
  // console.log("Hello Sagas!");
}
